(function() {
  var productData = null;
  var allVariants = null;
  var isUpdating = false;
  var origFetch = window.fetch;
  var pendingFix = false;
  var colorMediaIds = {};

  function init() {
    var path = window.location.pathname;
    if (path.indexOf('/products/hyperbelt') === -1) return;

    interceptFetch();

    var handle = path.split('/products/')[1].split('?')[0].split('#')[0];
    origFetch.call(window, '/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        productData = product.variants;
        allVariants = product.variants;
        buildColorMediaMap();
        applyLabels();
        setupObserver();
        resetSizeToPlaceholder();
      });
  }

  function buildColorMediaMap() {
    if (!allVariants) return;
    var counts = {};
    allVariants.forEach(function(v) {
      if (!v.featured_media) return;
      var color = v.option2;
      if (!counts[color]) counts[color] = {};
      var mid = v.featured_media.id;
      counts[color][mid] = (counts[color][mid] || 0) + 1;
    });
    Object.keys(counts).forEach(function(color) {
      var medias = counts[color];
      var best = null;
      var bestCount = 0;
      Object.keys(medias).forEach(function(mid) {
        if (medias[mid] > bestCount) {
          bestCount = medias[mid];
          best = parseInt(mid);
        }
      });
      colorMediaIds[color] = best;
    });
  }

  function getSelectedColor() {
    var container = document.querySelector('high-variant-selects');
    if (!container) return null;
    var color = container.querySelector('input[type="radio"][name*="Color"]:checked, input[type="radio"][name*="color"]:checked');
    return color ? color.value : null;
  }

  function forceGalleryToColor(colorValue) {
    var mediaId = colorMediaIds[colorValue];
    if (!mediaId) return;
    var hvs = document.querySelector('high-variant-selects');
    if (!hvs) return;
    var mediaGallery = document.getElementById('Media-Gallery-' + hvs.dataset.section);
    if (mediaGallery && mediaGallery.updateGallery) {
      mediaGallery.updateGallery(mediaId);
      setTimeout(function() {
        var slide = document.querySelector('.product-media-item.is-current-variant-media');
        if (slide) {
          var imgs = slide.querySelectorAll('img');
          imgs.forEach(function(img) {
            if (img.srcset && (!img.src || img.src.indexOf('transparent') > -1)) {
              var firstSrc = img.srcset.split(',')[0].trim().split(' ')[0];
              if (firstSrc) img.src = firstSrc;
            }
            img.loading = 'eager';
          });
        }
      }, 50);
    }
  }

  function applyAllFixes() {
    applyLabels();
    var color = getSelectedColor();
    if (!color) return;
    var hvs = document.querySelector('high-variant-selects');
    if (!hvs) return;
    var sizeSelect = hvs.querySelector('select.select-select');
    var sizeVal = sizeSelect ? sizeSelect.value : '';
    var variant = null;
    if (sizeVal && allVariants) {
      variant = allVariants.find(function(v) { return v.option1 === sizeVal && v.option2 === color; });
    }
    if (!sizeVal || !variant || !variant.available) {
      forceGalleryToColor(color);
    }
  }

  function interceptFetch() {
    window.fetch = function(url, options) {
      if (typeof url === 'string' && url.indexOf('option_values') > -1 && url.indexOf('section_id') > -1) {
        pendingFix = true;
      }
      return origFetch.apply(window, arguments);
    };
  }

  function applyLabels() {
    if (!productData) return;
    isUpdating = true;
    var container = document.querySelector('high-variant-selects');
    if (!container) { isUpdating = false; return; }
    var sizeSelect = container.querySelector('select.select-select');
    if (!sizeSelect) { isUpdating = false; return; }
    var color = container.querySelector('input[type="radio"][name*="Color"]:checked, input[type="radio"][name*="color"]:checked');
    if (!color) { isUpdating = false; return; }

    Array.from(sizeSelect.options).forEach(function(opt) {
      if (!opt.value) return;
      var cleanText = opt.text.replace(/ – Sold out$/, '');
      var variant = productData.find(function(v) {
        return v.option1 === opt.value && v.option2 === color.value;
      });
      if ((variant && !variant.available) || !variant) {
        opt.text = cleanText + ' – Sold out';
      } else {
        opt.text = cleanText;
      }
    });

    var colorInputs = container.querySelectorAll('.color-swatch input.disabled');
    colorInputs.forEach(function(input) {
      input.classList.remove('disabled');
    });

    setTimeout(function() { isUpdating = false; }, 100);
  }

  function setupObserver() {
    var container = document.querySelector('high-variant-selects');
    if (!container) return;
    var observer = new MutationObserver(function() {
      if (!isUpdating) {
        setTimeout(function() {
          applyLabels();
          if (pendingFix) {
            pendingFix = false;
            applyAllFixes();
          }
        }, 50);
      }
    });
    observer.observe(container, { childList: true, subtree: true, attributes: true });
  }

  function resetSizeToPlaceholder() {
    var container = document.querySelector('high-variant-selects');
    if (!container) return;
    var sizeSelect = container.querySelector('select.select-select');
    if (!sizeSelect) return;
    var placeholder = sizeSelect.querySelector('option[value=""]');
    if (placeholder) {
      sizeSelect.selectedIndex = 0;
      var display = container.querySelector('.form-options-wrapper.select .select-styled');
      if (display) display.textContent = 'Select a Size';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); });
  } else {
    init();
  }
})();
